import { Typography } from "@trustpilot/businessapp-patternlibrary";
import React from "react";

import { splitDomain } from "../helpers";
import Icons from "./icons";
import {
  StyledSelectorButton,
  SelectorButtonInfo,
  SelectorButtonInfoCompany,
  SelectorButtonInfoDomain,
  SelectorButtonDomainPart,
  SelectorButtonDomainSuffix,
  SelectorButtonLockIcon,
  StyledArrowDownIcon,
  StyledToggle,
} from "./styled";
import * as Types from "./types";

const SelectorButton: React.FC<Types.SelectorButton> = ({
  company,
  domain,
  isInReadOnlyMode,
  isSelectorVisible,
  showBusinessUnitConsents,
  toggleSelector,
  isCollapsed,
  setIsCollapsed,
}) => {
  const toggleClick = (e) => {
    e.stopPropagation();
    setIsCollapsed(false);
  };

  return (
    <StyledSelectorButton data-key="SelectorButton" onClick={toggleSelector}>
      {isCollapsed ? (
        <React.Fragment>
          <StyledToggle onClick={toggleClick}>
            <Icons.CollapsedMenuToggle />
          </StyledToggle>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <SelectorButtonInfo>
            {company !== domain && <SelectorButtonInfoCompany>{company}</SelectorButtonInfoCompany>}
            <SelectorButtonInfoDomain title={domain}>
              <Typography variant="body-s">
                <SelectorButtonDomainPart>{splitDomain(domain)[0]}</SelectorButtonDomainPart>
                <SelectorButtonDomainSuffix>{splitDomain(domain)[1]}</SelectorButtonDomainSuffix>
              </Typography>
            </SelectorButtonInfoDomain>
          </SelectorButtonInfo>

          {showBusinessUnitConsents && isInReadOnlyMode && (
            <SelectorButtonLockIcon>
              <Icons.Lock />
            </SelectorButtonLockIcon>
          )}

          <StyledArrowDownIcon aria-hidden>
            <Icons.CaretDescending isOpen={isSelectorVisible} />
          </StyledArrowDownIcon>
        </React.Fragment>
      )}
    </StyledSelectorButton>
  );
};

export default SelectorButton;
